<template>
  <a-auto-complete
    style="width: 320px"
    :placeholder="fieldNamePlace"
    option-label-prop="text"
    @select="onSelect"
    @search="onSearch"
  >
    <template slot="dataSource">
      <a-select-option
        v-for="item in dataSource"
        :key="item"
      >
        {{ item }}
      </a-select-option>
    </template>
    <a-input>
      <i
        slot="suffix"
        class="iconfont iconicon-test45"
      />
    </a-input>
  </a-auto-complete>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    dataSource: {
      type: Array,
      default: () => {}
    }
  },
  computed: {
    fieldNamePlace () {
      return this.$t('message["1128"]')
    }
  },
  methods: {
    onSelect (value) {
      this.$emit('select', value)
    },
    onSearch (value) {
      this.$emit('search', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.iconicon-test45 {
  color: #d6d6d6
}
</style>
